export const ACCOUNT_KEY_IN_SESSION = 'IMMA-ACCOUNT';
export const ACCOUNT_TOKEN = 'IMMA-ACCOUNT-TOKEN';

export const LAST_SNAPSHOT_TOKEN = 'IMMA-LAST-SNAPSHOT';
export const CONSOLE_HOME_SEARCHED = 'IMMA-CONSOLE-HOME-SEARCHED';
